import { ColumnDef, Header, LoadingSpinner, Table, Text } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';

import { useDraftReferralRequests } from './hooks/use-draft-referral-requests';
import { DraftReferralRequestResult } from './types';
import { useTableColumns } from './use-table-columns';

const PAGE_SIZE = 10;

type DraftReferralRequestsTableProps = {
  readonly columns: ColumnDef<DraftReferralRequestResult>[];
  readonly draftReferralRequests: DraftReferralRequestResult[];
  readonly error?: unknown;
  readonly fetching: boolean;
};

const DraftReferralRequestsTable = ({
  columns,
  draftReferralRequests,
  error,
  fetching,
}: DraftReferralRequestsTableProps) => {
  const { t } = useTranslation();

  if (fetching) return <LoadingSpinner />;

  if (error) return <Text className="mt-4">{t('page.professionalReferral.home.draftsError')}</Text>;

  return (
    <Table
      className="mt-4"
      columns={columns}
      data={draftReferralRequests}
      getRowId={(draftReferralRequest) => draftReferralRequest.id}
      manipulationOptions={{ type: 'clientSide', filtersState: [] }}
      pageSize={PAGE_SIZE}
    />
  );
};

const DraftReferralRequests = () => {
  const { t } = useTranslation();
  const { draftReferralRequests, fetching, error } = useDraftReferralRequests();
  const columns = useTableColumns();

  return (
    <>
      <Header className="mt-4" level="h2">
        {t('page.professionalReferral.home.draftReferralRequests')}
      </Header>
      <DraftReferralRequestsTable
        columns={columns}
        draftReferralRequests={draftReferralRequests}
        error={error}
        fetching={fetching}
      />
    </>
  );
};

export { DraftReferralRequests };
